import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';

import authMiddleware from 'auth/authMiddleware';

import { cancelPreviousLink } from './cancelPreviousLink';
import { errorLink } from './errorLink';

const backendURL =
	process.env.NODE_ENV === 'development' ? 'https://dispatch-dev.crew-dev.flix.tech' : '';
const graphqLink = new HttpLink({ uri: `${backendURL}/graphql` });

export const client = new ApolloClient({
	link: ApolloLink.from([authMiddleware, cancelPreviousLink, errorLink, graphqLink]),
	cache: new InMemoryCache(),
});
